import React, { useEffect, useState, useRef } from "react";


export const CusotomSearch = (props) => {

    const [value,setValue]=useState("")

    useEffect(() => {
     if(props?.searchVal === ""){
      setValue("")
     }
  }, [props?.searchVal]);

    //function to handle on change
  const handleChange =  (e) => {
   setValue(e)
   props?.onChange(e)

    };

    return(
    <div className="input-group rounded border w-25 mx-4 my-2 justify-content-center align-items-center">
  <input type="search" value={value} onChange={(e) => handleChange(e.target?.value)} className="form-control text-decoration-none  rounded border-0" placeholder="Search" aria-label="Search term" aria-describedby="search-clear-icon" />
  {
    value ===  "" ? 
    <span className=" input-group-append mx-2">
  <i className="bi bi-search text-danger"></i>
  </span> :
  null
  }
  
</div>
    )
}